import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import query from '@/api/APIServices'
import { CategoryParams } from '@/interfaces/containerCategory'

export const GET_ALL_CATEGORIES_QUERY_KEY = 'categories'
export const GET_CATEGORY_QUERY_KEY = (categoryId: number) => [
  'category',
  categoryId,
]

export function useGetCategories() {
  return useQuery({
    queryKey: [GET_ALL_CATEGORIES_QUERY_KEY],
    queryFn: async () => {
      const response = await query.get('/cargo/category')
      return response.data
    },
  })
}

export function useGetCategory(categoryId: number) {
  return useQuery({
    queryKey: [GET_CATEGORY_QUERY_KEY, categoryId],
    queryFn: async () => {
      const response = await query.get(`/cargo/category/${categoryId}`)
      return response.data
    },
    enabled: !!categoryId,
  })
}

export function useCreateCategory() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: CategoryParams) => {
      const response = await query.post('/cargo/category', data)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ALL_CATEGORIES_QUERY_KEY],
      })
    },
  })
}

export function useUpdateCategory(categoryId: number) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: CategoryParams) => {
      const response = await query.put(`/cargo/category/${categoryId}`, data)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          GET_CATEGORY_QUERY_KEY(categoryId),
          GET_ALL_CATEGORIES_QUERY_KEY,
        ],
      })
    },
  })
}

export function useDeleteCategory() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (expedientId: number) => {
      const response = await query.deleteAPI(`/category/${expedientId}`)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ALL_CATEGORIES_QUERY_KEY],
      })
    },
  })
}
